module.exports = __webpack_public_path__ + "static/media/blogpost3.064f9a6a.jpg";